
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#EBF2FA"}}),_c('g',{attrs:{"clip-path":"url(#clip0_6223_49810)","fill":"#A0AEC0"}},[_c('path',{attrs:{"d":"M11.602 6.37c.138.122.15.333.028.47l-.889 1a.334.334 0 01-.498 0l-.445-.5a.333.333 0 01.499-.442l.195.22.64-.72a.333.333 0 01.47-.028zM9.604 8.311c.533 0 .965.419.965.935l-.001.467c.066 1.145-.843 1.715-2.53 1.715-1.68 0-2.61-.563-2.61-1.699v-.483c0-.516.432-.935.965-.935h3.211zm0 .624H6.393a.317.317 0 00-.322.311v.483c0 .714.597 1.076 1.968 1.076 1.365 0 1.928-.353 1.887-1.075v-.484a.317.317 0 00-.322-.311zM8 4.57c.888 0 1.607.698 1.607 1.559 0 .86-.72 1.558-1.607 1.558-.888 0-1.608-.697-1.608-1.558 0-.86.72-1.559 1.608-1.559zm0 .624c-.533 0-.965.418-.965.935 0 .516.432.935.965.935.533 0 .964-.419.964-.935 0-.517-.431-.935-.964-.935z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6223_49810"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(4 4)","d":"M0 0h8v8H0z"}})])])])
          )
        }
      }
    